import { render, staticRenderFns } from "./index.vue?vue&type=template&id=14afd89b&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=14afd89b&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14afd89b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14afd89b')) {
      api.createRecord('14afd89b', component.options)
    } else {
      api.reload('14afd89b', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=14afd89b&scoped=true", function () {
      api.rerender('14afd89b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cratePeremption/index.vue"
export default component.exports